import { forwardRef } from "react";
import { Typography } from "@mui/material";
import { TextField, Autocomplete } from "@mui/material";
import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const ActivityDomainQuestion = forwardRef(
  (
    {
        handleEdit,
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      value,
      isEdit,
      latestStepQuestion,
    },
    ref
  ) => {
    // const [myAnswer, setMyAnswer] = useState(null);
    const handleSelectChange = (value) => {
      handlePayload(data, value);
    };
    const { t } = useTranslation();

    const isMobile = useMediaQuery("(max-width:900px)");

    const nextQuestionHandler = (height, value) => {
      handlePayload(data, value);
      scrollToQuestion(data, height, value);
    };
    const filterOptions = (options, { inputValue }) => {
      const trimmedInput = inputValue.trim().toLowerCase(); 
    
      const filtered = options.filter((option) => {
        const translatedOption = t(option).toLowerCase(); 
        return translatedOption.includes(trimmedInput); 
      });

      return filtered; 
    };
    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          {/* <br></br> */}
          <Grid container>
            <Autocomplete
              // onChange={handleSelectChange}
              value={value}
              onChange={(event, value) => handleSelectChange(value)}
              disablePortal
              id="combo-box-demo"
              options={data.choises}
              defaultValue={data.key === "head_office_country_B" ? "FR" : ""}
              getOptionLabel={(option) => t(option)}
              filterOptions={data?.key === "head_office_country_B" ? filterOptions : undefined} 
              sx={{ mt: 2 }}
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    data.key === "head_office_country_B"
                      ? t("country")
                      : t("activity_field")
                  }
                />
              )}
            />
          </Grid>

          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={() => {
                  nextQuestionHandler(ref.current.clientHeight, value);
                }}
                //   onClick={handleEdit}
                disabled={data.required && !value}
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default ActivityDomainQuestion;
